import { apiReducer, combineReducers, coreReducer, customizationReducer, uiReducer } from '@va/dashboard/reducers';
import appReducer from './appReducer';

const rootReducer = combineReducers({
  core: coreReducer,
  api: apiReducer,
  ui: uiReducer,
  customization: customizationReducer,
  app: appReducer,
});

export default rootReducer;
